define('presentation/settings/callQueues/facades/callQueuesFacade',[
    'externalDependencies/clientWebSocket',
    'presentation/common/dateTimeValue',
    'presentation/settings/callQueues/presentationObjects/callQueuePresentationObject',
    'settings/navigationConfiguration',
], function() {
    const DateTimeValueConstructor = require('presentation/common/dateTimeValue');
    const CallQueuePresentationObjectConstructor = require('presentation/settings/callQueues/presentationObjects/callQueuePresentationObject');

    const callQueueSocket = require('externalDependencies/clientWebSocket').forApplication("callQueue");

    const _navigationConfiguration = require('settings/navigationConfiguration');

    let _promiseFactory = null;

    const _getCallQueues = () => {
        return _promiseFactory.defer((deferredObject) => {
            callQueueSocket.send("getCallQueueList", {}, (result, err) => {
                if (err) {
                    deferredObject.reject(new Error(err));
                    return;
                }

                const displayCallQueues = result.callQueues.map((currentCallQueue) => {
                    const displayCallQueue = new CallQueuePresentationObjectConstructor();
                    displayCallQueue.accountCallQueueId = currentCallQueue.accountCallQueueId;
                    displayCallQueue.name = currentCallQueue.name;
                    displayCallQueue.poolCount = currentCallQueue.pools.length;
                    displayCallQueue.maxCallersInQueue = currentCallQueue.maxCallersInQueue;
                    displayCallQueue.createdDateTime = new DateTimeValueConstructor(currentCallQueue.createdDateTime);
                    displayCallQueue.modifiedDateTime = new DateTimeValueConstructor(currentCallQueue.updatedDateTime);
                    displayCallQueue.editCallQueueUrl = _navigationConfiguration.routesById.editCallQueue.baseUrl + currentCallQueue.accountCallQueueId;

                    return displayCallQueue;
                });

                deferredObject.resolve(displayCallQueues);
            });
        });
    };

    const _deleteCallQueue = (accountCallQueueId) => {
        return _promiseFactory.defer((deferredObject) => {
            callQueueSocket.send("deleteCallQueue", {accountCallQueueId: accountCallQueueId}, (result, err) => {
                if (err) {
                    deferredObject.reject(new Error(err));
                    return;
                }

                deferredObject.resolve(result.isUsedByCallflow);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        const self = this;

        self.init = _init;
        self.deleteCallQueue = _deleteCallQueue;
        self.getCallQueues = _getCallQueues;
    };
});

